import {Component, Input, OnInit} from '@angular/core';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {InteractionCardDto} from '../../models/card.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-card-audio',
  templateUrl: './card-audio.component.html',
  styleUrls: ['./card-audio.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, TranslateModule],
})
export class CardAudioComponent implements OnInit {
  @Input() card: InteractionCardDto;
  @Input() title: string;
  @Input() audio: string;

  color;
  player;
  duration;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.player = document.querySelector<HTMLAudioElement>('#audio-player');
    this.player.addEventListener('loadedmetadata', () => {
      this.duration = this.player.duration;
    });
  }

  play() {
    if (this.duration) {
      document.getElementById('btn-pause').classList.remove('hide');
      document.getElementById('btn-play').classList.add('hide');
      this.player.play();
    }
  }

  pause() {
    document.getElementById('btn-play').classList.remove('hide');
    document.getElementById('btn-pause').classList.add('hide');
    this.player.pause();
  }

  round(n) {
    if (n) {
      return Math.round(n);
    } else {
      return '...';
    }
  }
}
